import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { useSite } from "../contexts/SiteContext";

export default function DiscountPopup() {
  const { settings, loaded } = useSite();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!loaded) return;
    const dismissed = localStorage.getItem("popup_dismissed_at");
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    if (dismissed && Date.now() - parseInt(dismissed) < sevenDays) return;
    if (settings.popup_enabled) {
      const t = setTimeout(() => setShow(true), 2500);
      return () => clearTimeout(t);
    }
  }, [loaded, settings]);
  if (!show) return null;
  const dismiss = () => { localStorage.setItem("popup_dismissed_at", String(Date.now())); setShow(false); };
  return (
    <div data-testid="discount-popup" className="fixed inset-0 z-50 flex items-center justify-center p-6 maintenance-blur">
      <div className="relative max-w-md w-full bg-white border-2 border-copper p-10 text-center shadow-2xl">
        <button data-testid="popup-close" onClick={dismiss} className="absolute top-4 right-4 text-gray-400 hover:text-dark"><X size={18}/></button>
        <Sparkles size={28} className="mx-auto text-copper mb-4"/>
        <div className="overline mb-3">Exclusive offer</div>
        <h2 className="font-display text-3xl text-dark leading-tight">{settings.popup_title}</h2>
        <p className="text-sm text-gray-600 mt-3 mb-6 leading-relaxed">{settings.popup_body}</p>
        <div className="bg-[#FAF7F2] border border-copper/40 py-4 mb-5">
          <div className="text-[10px] uppercase tracking-luxe text-gray-500 mb-1">Use code</div>
          <div data-testid="popup-code" className="font-display text-2xl text-copper tracking-widest">{settings.popup_code}</div>
        </div>
        <button data-testid="popup-shop" onClick={() => { dismiss(); window.location.href = "/shop"; }} className="btn-primary w-full justify-center">Shop the Collection</button>
      </div>
    </div>
  );
}
